// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"AccountScreen_buttonsContainer__PP3bV","button":"AccountScreen_button__uGPQF"};